import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quick-ship__wrapper" }
const _hoisted_2 = { class: "quick-ship__text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://images.baldwinhardware.com/is/image/Baldwin/quickship-tiny?wid=121&qlt=100&op_sharpen=1",
  alt: "Quick Ship",
  class: "mr-2"
}, null, -1 /* HOISTED */)
const _hoisted_4 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  props: {
    imageUrl: {
        type: String,
        default: '',
    },
    displayName: {
        type: String,
        default: '',
    },
    description: {
        type: String,
        default: null,
    },
    route: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props

const componentName = 'StandardShipping';


const onSwitchChange = (isSelected: boolean) => {
    // console.log({ isSelected });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", {
        class: "quick-ship__description",
        innerHTML: __props.description
      }, null, 8 /* PROPS */, _hoisted_4)
    ])
  ]))
}
}

})